export default "__VITE_PUBLIC_ASSET__ef3411e8__"